import { connect } from 'react-redux';
import {
  LABEL_FOR_AVM_KEY,
  SECTION_ID_RENTAL_REPORT
} from 'legacy/appstore/constants';

import { avmsUpdateUserEnteredRentalValue } from 'actions/avms';
import { changeGlossarySelected } from 'actions/support';

import {
  getAvmRentalSelected,
  getAvmRentalSelectedKey,
  getAvmRentalShowBarChart,
  getAvmRentalHc,
  getAvmRentalSelectorUserEntered
} from 'selectors/avms';
import {
  getRentalCompsFarmExists,
  getRentalCompsSelectedOrSuggestedIdsOrderedBySimilarity,
  getRentalCompsSelectedOrSuggestedMessage,
  getRentalCompsSelectionButtonView,
  getRentalCompsHideGallery,
  getRentalCompsSelectionButtonLabel
} from 'selectors/rental-comps';
import { getIsReportEditable } from 'selectors/report-permissions';
import {
  getReportStatusInitialLoadComplete,
  getReportStatusRentalReportIsLoadedInitial
} from 'selectors/report-status';
import { getIsLessThanSmallMedium } from 'selectors/match-media';

import loadWhenReady from 'legacy/hocs/loadWhenReady';

import RentalReportSection from 'legacy/components/RentalReportSection';

const mapStateToProps = (state) => {
  const selectedAvmKey = getAvmRentalSelectedKey(state);
  const rentalAvmHc = getAvmRentalHc(state);
  const hasRentalComps = getRentalCompsFarmExists(state);
  return {
    avmLabel: LABEL_FOR_AVM_KEY[selectedAvmKey],
    isMonthlyValue: true,
    selectedAvm: getAvmRentalSelected(state),
    hasRentalAvm: rentalAvmHc && rentalAvmHc.value,
    errorRateForState: 2.5,
    dataHcNames: {
      barChart: 'rental-valuation-bar-chart',
      section: 'rental-valuation-section',
      header: 'rental-comps-header',
      button: 'select-rental-comps-button',
      sectionComps: 'rental-comps-section',
      gallery: 'rental-comps-gallery'
    },
    rentalReportHasLoaded: getReportStatusRentalReportIsLoadedInitial(state),
    showBarChart: getAvmRentalShowBarChart(state),
    title: 'HouseCanary Rental Details',
    buttonLabel: getRentalCompsSelectionButtonLabel(state),
    isMobile: getIsLessThanSmallMedium(state),
    isReportLoaded: getReportStatusInitialLoadComplete(state),
    isReportEditable: getIsReportEditable(state),
    message: getRentalCompsSelectedOrSuggestedMessage(state),
    addressIds: getRentalCompsSelectedOrSuggestedIdsOrderedBySimilarity(state),
    avmSelectorUserEntered: getAvmRentalSelectorUserEntered(state),
    viewButton: getRentalCompsSelectionButtonView(state),
    hideCompGallery: getRentalCompsHideGallery(state),
    selectedAvmKey,
    hasRentalComps
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleClickInfo: () => dispatch(changeGlossarySelected(['RENTAL_COMPS'])),
  handleChangeUserEnteredValue: (value) =>
    dispatch(avmsUpdateUserEnteredRentalValue(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(loadWhenReady(RentalReportSection, SECTION_ID_RENTAL_REPORT));
